import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DateState = {
	selectedDate: Date | undefined
}

const initialState: DateState = {
	selectedDate: undefined
}

const dateSlice = createSlice({
	name: 'dateSlice',
	initialState,
	reducers: {
		selectDate: (state, action: PayloadAction<Date>) => {
			state.selectedDate = action.payload;
		}
	}
})

export const actions = { ...dateSlice.actions }
export default dateSlice.reducer;